import { createCRUDHook } from './createCRUDHook';
import { PartCreditMultiplierDto } from 'utils/models';
import { TBL_PART_CREDIT_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<PartCreditMultiplierDto>({
    entityName: 'PartCreditMultiplier',
    endpoint: TBL_PART_CREDIT_MULTIPLIER,
  });

export const PartCreditMultiplierContext = Context;
export const usePartCreditMultiplierManager = useManager;
export const usePartCreditMultiplier = useConsumer;
